import { render } from "./Acquisitions.vue?vue&type=template&id=1260224d&scoped=true"
import script from "./Acquisitions.vue?vue&type=script&lang=js"
export * from "./Acquisitions.vue?vue&type=script&lang=js"

import "./Acquisitions.vue?vue&type=style&index=0&id=1260224d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1260224d"]])

export default __exports__